import React from "react";
import { FollowersRange } from "../../../Task/tabs/ProfileDataTab/single/FollowersRange";

export const renderFollowersRange = (label, data, layout, GridBoxComponent) => {
  const { followersRange } = data;

  const key = label;

  const height = layout?.find((item) => item.i === key)?.h;

  return (
    <GridBoxComponent key={key} id={key}>
      <FollowersRange followersRange={followersRange} height={height} />
    </GridBoxComponent>
  );
};
